module.exports = __webpack_public_path__ + "media/images/application/icons/award-d0a4c16d43d6900d0c40c90eaafa7e0e.svg";